// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","650":"component---src-pages-contact-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"12098ce81880c4e0cfb7","650":"6e737266678d81225c88","691":"6ab917944e4fb9652169"}[chunkId] + ".js";
};